
import React from "react";
import CTASection from "@/components/CTASection";

const OutdoorCoachingCTA: React.FC = () => {
  return (
    <CTASection 
      title="Bereit für neue Perspektiven?" 
      description="Erlebe, wie das Outdoor-Coaching am Rothsee dir hilft, mit frischem Blick auf das zu schauen, was dich wirklich beschäftigt – und konkrete nächste Schritte zu entwickeln."
      primaryCTA={{ text: "Erstgespräch vereinbaren (kostenfrei)", link: "https://zeeg.me/joerghoermann", isExternal: true }}
      backgroundClass="bg-gradient-to-br from-[#EDF5E9] to-[#E8F1FB] text-joerg-800"
    />
  );
};

export default OutdoorCoachingCTA;
